import React from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
   mainContent: {
      display: 'flex',
      flexFlow: 'column',
      height: '100%',
      flexGrow: 1,
      backgroundColor: '#F9FAFC'
   },
   mainContentToolbar: {
      flex: '0 1 auto',
      minHeight: '47px'
   }
}))

const MainContent = ({ children }) => {
   const classes = useStyles()

   return (
      <main className={classes.mainContent}>
         <div className={classes.mainContentToolbar} />
         {children}
      </main>
   )
}

export default MainContent
